import { mark } from "../i18n";

// Time-based XP. Players earn XP for every minute spent in a room;
// minutes in an active game are worth more than minutes in the lobby.
export const XP_PER_MIN_PLAYING = 10;
export const XP_PER_MIN_LOBBY = 4;
export const XP_WIN_BONUS = 25;
export const XP_TICK_MS = 60_000;
// Must match the cap in firestore.rules.
export const XP_MAX_PER_TICK = 50;

// XP needed to go from `level` to `level + 1`.
export const xpToNext = (level) => 100 + (level - 1) * 50;

export function levelInfo(totalXp = 0) {
  let level = 1;
  let remaining = Math.max(0, Math.floor(totalXp));
  while (remaining >= xpToNext(level)) {
    remaining -= xpToNext(level);
    level += 1;
  }
  const needed = xpToNext(level);
  return { level, into: remaining, needed, pct: remaining / needed };
}

// Titles are shown translated: t(levelTitle(level)).
const TITLES = [
  [1, mark("Fresh Doodle")],
  [3, mark("Card Shark Jr.")],
  [5, mark("Party Starter")],
  [8, mark("Sketch Wizard")],
  [12, mark("Guess Master")],
  [16, mark("Arcade Legend")],
  [20, mark("PartyCade Royalty")],
];

export function levelTitle(level) {
  let title = TITLES[0][1];
  for (const [min, t] of TITLES) if (level >= min) title = t;
  return title;
}
